// extracted by mini-css-extract-plugin
module.exports = {"container":"prefooter_container__SSblp"};